'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _CamError = require('./CamError');

var _CamError2 = _interopRequireDefault(_CamError);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _CamError2.default;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/CamError/index.js
// module id = 533
// module chunks = 11